import React from 'react';
import { useTranslation } from 'react-i18next';
import { Save } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Accordion } from '../ui/accordion';
import AbsenceBasicInfoSection from './AbsenceBasicInfoSection';
import AbsenceFinancialAccordion from './AbsenceFinancialAccordion';
import AbsenceCategorizationAccordion from './AbsenceCategorizationAccordion';
import AbsenceBalanceAccordion from './AbsenceBalanceAccordion';
import AbsenceRestrictionsAccordion from './AbsenceRestrictionsAccordion';

const AbsenceReasonFormDialog = ({
  showModal, setShowModal, isEditing,
  formData, updateField, categories, handleSubmit,
}) => {
  const { t } = useTranslation();

  return (
  <Dialog open={showModal} onOpenChange={setShowModal}>
    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>
          {isEditing ? t('absenceReasons.form.editTitle') : t('absenceReasons.form.newTitle')}
        </DialogTitle>
        <DialogDescription>
          {isEditing
            ? t('absenceReasons.form.editDesc')
            : t('absenceReasons.form.newDesc')}
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-6 py-4">
        <AbsenceBasicInfoSection formData={formData} updateField={updateField} categories={categories} />

        <Accordion type="multiple" className="w-full">
          <AbsenceFinancialAccordion formData={formData} updateField={updateField} />
          <AbsenceCategorizationAccordion formData={formData} updateField={updateField} />
          <AbsenceBalanceAccordion formData={formData} updateField={updateField} />
          <AbsenceRestrictionsAccordion formData={formData} updateField={updateField} />
        </Accordion>

        <div className="flex items-center space-x-2 pt-4">
          <Checkbox
            id="is_active"
            checked={formData.is_active}
            onCheckedChange={(checked) => updateField('is_active', checked)}
          />
          <Label htmlFor="is_active" className="cursor-pointer">{t('absenceReasons.form.activeReason')}</Label>
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => setShowModal(false)}>{t('common.cancel')}</Button>
        <Button onClick={handleSubmit}>
          <Save className="mr-2 h-4 w-4" />
          {isEditing ? t('absenceReasons.form.updateAction') : t('common.create')}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  );
};

export default AbsenceReasonFormDialog;
